<h2 mat-dialog-title class="dialog-title">{{data.productName}}</h2>

<div mat-dialog-content class="dialog-content">
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Quantity</mat-label>
    <div class="quantity-input-container">
      <button mat-mini-button type="button" (click)="decreaseQuantity()" [disabled]="data.quantity <= 1">−</button>
      <input matInput type="number" min="1" [(ngModel)]="data.quantity">
      <button mat-mini-button type="button" (click)="increaseQuantity()">+</button>
    </div>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Price</mat-label>
    <input matInput type="number" min="0" step="0.01" [(ngModel)]="data.price">
  </mat-form-field>
</div>

<div mat-dialog-actions align="end" class="dialog-actions">
  <button mat-stroked-button color="warn" (click)="deleteItem()">Delete</button>
  <button mat-stroked-button (click)="dialogRef.close()">Cancel</button>
  <button mat-flat-button color="primary" (click)="save()">Save</button>
</div>
